import {styledByTheme} from '../../../../themes/architecture/styled-by-theme';
import {RedTigerWidget777Box} from './red-tiger-widget.777.box';
import {RedTigerWidgetDefaultBox} from './red-tiger-widget.default.box';

export const RedTigerWidgetBox = styledByTheme(RedTigerWidgetDefaultBox).forCasino777(RedTigerWidget777Box).apply();
